import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const DeleteIcon = ({ stroke, fill, active,className, ...props }) => {
  const useStyles = makeStyles({
    a: {
      fill: fill || "red",
      opacity: active ? 1 : 0.3,
      borderRadius: `0!important`,
      stroke: stroke || "red",
      strokeWidth: "0.3px",
    },
    b: {
      clipPath: "url(#a)",
    },
  });
  const classes = useStyles();
  return (
    <svg
      xmlns="http://www.w3.org/1999/xlink"
      width={"12.206" || props.width}
      height={"12.53" || props.height}
      viewBox="0 0 12.206 12.53"
      className={className}
    >
      <clipPath id="a">
        <rect className={classes.a} width="12.206" height="12.53" />
      </clipPath>
      <g className={classes.b}>
        <path
          className={classes.a}
          d="M8.189,12.53A2.311,2.311,0,0,0,10.5,10.3l.246-7.45h1a.462.462,0,0,0,0-.924H8.666V1.385A1.38,1.38,0,0,0,7.281,0H4.941A1.38,1.38,0,0,0,3.556,1.385v.539H.462a.462.462,0,1,0,0,.924h1l.246,7.45A2.311,2.311,0,0,0,4.018,12.53ZM4.479,1.385A.454.454,0,0,1,4.941.924h2.34a.454.454,0,0,1,.462.462v.539H4.479ZM2.648,10.267,2.4,2.848H9.821l-.246,7.419a1.38,1.38,0,0,1-1.385,1.339H4.033a1.37,1.37,0,0,1-1.385-1.339Z"
        />
        <path
          className={classes.a}
          d="M205.98,166.249a.454.454,0,0,0,.462-.462v-4.6a.462.462,0,1,0-.924,0v4.6a.454.454,0,0,0,.462.462Z"
          transform="translate(-199.869 -156.305)"
        />
        <path
          className={classes.a}
          d="M139.241,165.788v-4.6a.462.462,0,1,0-.924,0v4.6a.462.462,0,1,0,.924,0Z"
          transform="translate(-134.515 -156.306)"
        />
        <path
          className={classes.a}
          d="M273.18,166.249a.454.454,0,0,0,.462-.462v-4.6a.462.462,0,1,0-.924,0v4.6a.454.454,0,0,0,.462.462Z"
          transform="translate(-265.222 -156.305)"
        />
      </g>
    </svg>
  );
};

export default DeleteIcon;
